<section class="tw-pl-4 tw-pt-6 tw-pb-5 tw-flex tw-flex-col tw-items-stretch tw-bg-gradient-shop-section tw-overflow-x-auto">
    <header class="tw-flex tw-items-center tw-justify-between tw-mb-4"
            (click)="viewCollection.emit(name())">
        <h2 class="tw-font-lexend tw-font-bold tw-text-500 tw-text-white tw-leading-none">{{title()}}</h2>
        <cs-icon class="tw-w-6 tw-h-6 tw-text-white" [iconName]="'chevron_right'" />
    </header>
    <ng-content></ng-content>
</section>